import { render, staticRenderFns } from "./ABigScreemTitle.vue?vue&type=template&id=db1c76b4&scoped=true&"
import script from "./ABigScreemTitle.vue?vue&type=script&lang=js&"
export * from "./ABigScreemTitle.vue?vue&type=script&lang=js&"
import style0 from "./ABigScreemTitle.vue?vue&type=style&index=0&id=db1c76b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1c76b4",
  null
  
)

export default component.exports